import React, { useState, useEffect } from "react"
import { Table, Col, Row, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField } from "availity-reactstrap-validation"
import jsPDF from "jspdf"
import "jspdf-autotable"
import { usePermissions } from "API/PermissionContext"

const VLCCSettingsReport = () => {
  const { canExport, MODULE } = usePermissions()
  const MID = MODULE.REPORTS
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [settings, setSettings] = useState([])
  const [allChillings, setAllChillings] = useState([])
  const [chillings, setChillings] = useState([])
  const [routes, setRoutes] = useState([])
  const [collections, setCollections] = useState([])
  const [allPlants, setAllPlants] = useState([])
  const [plants, setPlants] = useState([])
  const [companies, setCompanies] = useState([])
  const [search, setSearch] = useState("")

  useEffect(() => { getData() }, [])

  const getData = async () => {
    try {
      const [chResp, pResp, coResp] = await Promise.all([
        api.get("centers"), api.get("plants"), api.get("companies")
      ])
      const ccs = Array.isArray(chResp.data.data) ? chResp.data.data : chResp.data.data?.data || []
      setAllChillings(ccs)
      setChillings(ccs)
      const pData = Array.isArray(pResp.data.data) ? pResp.data.data : pResp.data.data?.data || []
      setAllPlants(pData)
      setPlants(pData)
      setCompanies(Array.isArray(coResp.data.data) ? coResp.data.data : coResp.data.data?.data || [])
    } catch (e) { console.error(e) }
  }

  const showCompany = companies.length > 1

  const companyChange = async e => {
    const val = e.target.value
    setChillings(allChillings); setRoutes([]); setCollections([])
    if (val && val !== "") {
      try { const r = await api.get("plants-by-company/" + val); setPlants(Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || []) } catch(e){}
    } else setPlants(allPlants)
  }

  const plantChange = async e => {
    const val = e.target.value
    setRoutes([]); setCollections([])
    if (val && val !== "") {
      try {
        const r = await api.get("chillings-by-plant/" + val)
        setChillings(Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || [])
      } catch (e) { console.error(e) }
    } else {
      setChillings(allChillings)
    }
  }

  const chillingChangeHandler = async e => {
    try {
      const val = e.target.value
      const u = !val || val === "0" ? "routes" : "route-cc/" + val
      const r = await api.get(u)
      setRoutes(Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || [])
    } catch (e) { console.error(e) }
  }

  const routeChangeHandler = async e => {
    try {
      const val = e.target.value
      if (val && val !== "0") {
        const r = await api.get("collection-center-route/" + val)
        setCollections(Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || [])
      } else {
        const r = await api.get("collection-centers")
        setCollections(Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || [])
      }
    } catch (e) { console.error(e) }
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const resp = await api.post("reports/vlcc-settings", values)
      if (resp.data.success) {
        setSettings(resp.data.data || [])
      } else {
        setSettings([])
      }
      setSubmitted(true)
    } catch (error) {
      setSettings([])
      setSubmitted(true)
    }
    setLoading(false)
  }

  const downloadPdf = () => {
    const pdf = new jsPDF("l")
    pdf.setFontSize(14)
    pdf.text("VLCC Settings Report", 14, 15)
    pdf.autoTable({ html: "#vlccSettingsTbl", startY: 22, styles: { fontSize: 6 } })
    pdf.save("VLCC-Settings-Report.pdf")
  }

  const downloadCsv = () => {
    if (!settings.length) return
    let csv = "S.No,Company,Plant,CC,Route,Center No,Center Name,Rate Chart,SMS Receipt,Summary SMS,WhatsApp Receipt,Zero Rate,Session Timing,Add Producer,Edit Producer,Qty Input,FAT Input,SNF Input,Cleaning\n"
    settings.forEach((s, i) => {
      csv += `${i + 1},"${s.companyName || ''}","${s.plantName || ''}","${s.chillingCenterName || ''}","${s.routeName || ''}","${s.centerNo || ''}","${s.centerName || ''}","${fmtYesNo(s.rateChart)}","${fmtSms(s.smsReceipt)}","${fmtYesNo(s.smsSummary)}","${fmtWhatsapp(s.whatsappReceipt)}","${fmtYesNo(s.zeroRate)}","${fmtYesNo(s.session)}","${fmtYesNo(s.addProducer)}","${fmtYesNo(s.editProducer)}","${fmtQty(s.inputQuantity)}","${fmtFat(s.fatInput)}","${fmtSnf(s.snfInput)}","${fmtYesNo(s.cleaning)}"\n`
    })
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" })
    const link = document.createElement("a")
    link.href = URL.createObjectURL(blob)
    link.download = "VLCC-Settings-Report.csv"
    link.click()
  }

  // Formatters
  const fmtYesNo = v => v == 0 ? "No" : v == 1 ? "Yes" : "All"
  const fmtSms = v => v == 0 ? "No" : v == 1 ? "Yes" : v == 3 ? "Producerwise" : "All"
  const fmtWhatsapp = v => v == 0 ? "No" : v == 1 ? "Yes" : "All"
  const fmtQty = v => v == 1 ? "Manual" : v == 2 ? "Auto" : v == 3 ? "Both" : "All"
  const fmtFat = v => v == 0 ? "No" : v == 1 ? "Yes" : v == 2 ? "For CM Only" : v == 3 ? "For BM Only" : "All"
  const fmtSnf = v => v == 0 ? "No" : v == 1 ? "Yes" : v == 2 ? "For CM Only" : v == 3 ? "For BM Only" : "All"

  const filtered = search
    ? settings.filter(s =>
        (s.companyName || "").toLowerCase().includes(search.toLowerCase()) ||
        (s.plantName || "").toLowerCase().includes(search.toLowerCase()) ||
        (s.chillingCenterName || "").toLowerCase().includes(search.toLowerCase()) ||
        (s.routeName || "").toLowerCase().includes(search.toLowerCase()) ||
        (s.centerName || "").toLowerCase().includes(search.toLowerCase()) ||
        (s.centerNo || "").toString().includes(search)
      )
    : settings

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader notToPrint"><Row><Col md={12}><h4>VLCC Settings Report</h4></Col></Row></div>
      <div className="dashContent">
        <AvForm className="form-horizontal notToPrint" onValidSubmit={(e, v) => handleValidSubmit(e, v)}>
          {showCompany && <Row>
            <Col md={3}><div className="mb-3"><AvField type="select" name="company" label="Company" onChange={companyChange}><option value="">All</option>{companies.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}</AvField></div></Col>
          </Row>}
          <Row>
            <Col md={3}><div className="mb-3"><AvField type="select" name="plant" label="Plant" onChange={plantChange}><option value="">All Plants</option>{plants.map((p, i) => <option key={i} value={p.id}>{p.name}</option>)}</AvField></div></Col>
            <Col md={3}><div className="mb-3"><AvField type="select" name="chillingCenter" label="Chilling Center" onChange={chillingChangeHandler}><option value="">All Chilling Centers</option><option value="0">All Chilling Centers</option>{chillings.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}</AvField></div></Col>
            <Col md={3}><div className="mb-3"><AvField type="select" name="route" label="Route" onChange={routeChangeHandler}><option value="">All Routes</option><option value="0">All Routes</option>{routes.map((r, i) => <option key={i} value={r.id}>{r.routeName}</option>)}</AvField></div></Col>
            <Col md={3}><div className="mb-3"><AvField type="select" name="collectionCenter" label="Collection Center"><option value="">All Collection Centers</option><option value="0">All Collection Centers</option>{collections.map((c, i) => <option key={i} value={c.id}>{c.centerName}</option>)}</AvField></div></Col>
          </Row>
          <Row>
            <Col md={3}><div className="mb-3"><AvField type="select" name="rateChart" label="View Rate Chart"><option value="2">All</option><option value="1">Yes</option><option value="0">No</option></AvField></div></Col>
            <Col md={3}><div className="mb-3"><AvField type="select" name="smsReceipt" label="Purchase SMS Receipt"><option value="2">All</option><option value="0">No (Disabled)</option><option value="1">Yes (Enabled)</option><option value="3">Producerwise</option></AvField></div></Col>
            <Col md={3}><div className="mb-3"><AvField type="select" name="smsSummary" label="Summary SMS"><option value="2">All</option><option value="0">No (Disabled)</option><option value="1">Yes (Enabled)</option></AvField></div></Col>
            <Col md={3}><div className="mb-3"><AvField type="select" name="zeroRate" label="Allow Zero Rate"><option value="2">All</option><option value="1">Yes</option><option value="0">No</option></AvField></div></Col>
          </Row>
          <Row>
            <Col md={3}><div className="mb-3"><AvField type="select" name="session" label="Session Timing Restriction"><option value="2">All</option><option value="1">Yes</option><option value="0">No</option></AvField></div></Col>
            <Col md={3}><div className="mb-3"><AvField type="select" name="addProducer" label="Allow Producer Add"><option value="2">All</option><option value="1">Yes</option><option value="0">No</option></AvField></div></Col>
            <Col md={3}><div className="mb-3"><AvField type="select" name="editProducer" label="Allow Producer Edit"><option value="2">All</option><option value="1">Yes</option><option value="0">No</option></AvField></div></Col>
            <Col md={3}><div className="mb-3"><AvField type="select" name="inputQuantity" label="Allow Quantity Input"><option value="4">All</option><option value="1">Manual Only</option><option value="2">Auto Only</option><option value="3">Both</option></AvField></div></Col>
          </Row>
          <Row>
            <Col md={3}><div className="mb-3"><AvField type="select" name="fatInput" label="Allow FAT Input"><option value="">All</option><option value="1">Yes</option><option value="0">No</option><option value="2">For CM Only</option><option value="3">For BM Only</option></AvField></div></Col>
            <Col md={3}><div className="mb-3"><AvField type="select" name="snfInput" label="Allow SNF Input"><option value="4">All</option><option value="1">Yes</option><option value="0">No</option><option value="2">For CM Only</option><option value="3">For BM Only</option></AvField></div></Col>
            <Col md={3}><div className="mb-3"><AvField type="select" name="cleaning" label="Cleaning Required"><option value="2">All</option><option value="1">Yes</option><option value="0">No</option></AvField></div></Col>
            <Col md={3} className="d-flex align-items-end pb-3">
              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner animation="border" size="sm" /><span style={{ paddingLeft: "10px" }}>Submitting...</span></> : <><i className="fas fa-check me-1"></i>Submit</>}
              </button>
            </Col>
          </Row>
        </AvForm>

        {submitted && <>
          {canExport(MID) && <div className="exportBtns notToPrint mb-2">
            <button className="btn btn-info btn-sm m-1" onClick={downloadPdf}><i className="fas fa-file-pdf me-1"></i>PDF</button>
            <button className="btn btn-info btn-sm m-1" onClick={() => window.print()}><i className="fas fa-print me-1"></i>Print</button>
            <button className="btn btn-info btn-sm m-1" onClick={downloadCsv}><i className="fas fa-file-csv me-1"></i>CSV</button>
          </div>}
          <Row className="mb-2 notToPrint">
            <Col md={9}><span className="text-muted">Showing {filtered.length} of {settings.length} entries</span></Col>
            <Col md={3}><input type="text" className="form-control form-control-sm" placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)} /></Col>
          </Row>
          <div className="table-responsive">
            <Table id="vlccSettingsTbl" className="dairyTbl" size="sm" bordered>
              <thead>
                <tr>
                  <th>#</th>
                  {showCompany && <th>Company</th>}
                  <th>Plant</th><th>CC</th><th>Route</th><th>Center No</th><th>Center Name</th>
                  <th>View Rate Chart</th><th>SMS Receipt for Purchase</th><th>Summary SMS</th>
                  <th>Allow Zero Rate</th><th>Session Timing</th><th>Allow Producer Add</th>
                  <th>Allow Producer Edit</th><th>Allow Quantity Input</th>
                  <th>Allow FAT Input</th><th>Allow SNF Input</th><th>Cleaning Required</th>
                </tr>
              </thead>
              <tbody>
                {filtered.length > 0 ? filtered.map((s, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    {showCompany && <td>{s.companyName || '-'}</td>}
                    <td>{s.plantName || '-'}</td>
                    <td>{s.chillingCenterName || '-'}</td>
                    <td>{s.routeName || '-'}</td>
                    <td>{s.centerNo || '-'}</td>
                    <td>{s.centerName || '-'}</td>
                    <td>{fmtYesNo(s.rateChart)}</td>
                    <td>{fmtSms(s.smsReceipt)}</td>
                    <td>{fmtYesNo(s.smsSummary)}</td>
                    <td>{fmtYesNo(s.zeroRate)}</td>
                    <td>{fmtYesNo(s.session)}</td>
                    <td>{fmtYesNo(s.addProducer)}</td>
                    <td>{fmtYesNo(s.editProducer)}</td>
                    <td>{fmtQty(s.inputQuantity)}</td>
                    <td>{fmtFat(s.fatInput)}</td>
                    <td>{fmtSnf(s.snfInput)}</td>
                    <td>{fmtYesNo(s.cleaning)}</td>
                  </tr>
                )) : <tr><td colSpan={showCompany ? 18 : 17} className="text-center py-3">No Records Found</td></tr>}
              </tbody>
              {filtered.length > 0 && <tfoot><tr style={{ fontWeight: 700, background: "#f1f5f9" }}><td colSpan={showCompany ? 18 : 17}>Showing {filtered.length} of {settings.length} entries</td></tr></tfoot>}
            </Table>
          </div>
        </>}
      </div>
    </div>
  )
}

export default VLCCSettingsReport
